import { Card, Text, TextInput } from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeePersonalSection';

export const ContactCard: React.FC = () => {
  const form = useEmployeeFormContext();

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="lg">
        Kontaktní údaje
      </Text>

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="telefon"
        label="Telefon"
        {...form.getInputProps('phone')}
      />

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="email"
        label="E-mail"
        {...form.getInputProps('email')}
      />
    </Card>
  );
};
